// extracted by mini-css-extract-plugin
export var root = "StrengthRating-module--root--8EJB4";
export var rating = "StrengthRating-module--rating--1BKxt";